// Constant: Content > Terms of service update date
const TERMS_OF_SERVICE_UPDATE_DATE = '2024-11-18'

// Constant: Content > Volume time unit types
const VOLUME_TIME_UNIT_TYPES = Object.freeze(['MONTH', 'DAY', 'HOUR', 'MINUTE', 'SECOND'])

// Constant: Content > Volume unit types
const VOLUME_UNIT_TYPES = Object.freeze(['CHAR', 'REQUEST', 'TIME', 'TOKEN'])

// Export
export {
	TERMS_OF_SERVICE_UPDATE_DATE,
	VOLUME_TIME_UNIT_TYPES,
	VOLUME_UNIT_TYPES
}
